export default [
    {
        path: '/document-management',
        name: 'document-management',
        props: {parentRouteName: 'document-management'},
        component: () => import(/* webpackChunkName: "document-management" */ '@/components/AppModuleNavigator.vue'),
        meta: {
            title: 'DOCUMENT MANAGEMENT',
            icon: 'mdi-table-search',
            displayInNavigation: true
        },
        children: [
            {
                path: "projects-search",
                name: "projects-search",
                component: () =>
                    import(/* webpackChunckName: "document-management" */ "@/modules/projects/pages/Projects.vue"),
                meta: {
                    title: "PROJECTS",
                    icon: "mdi-table-search",
                    pageTitle: "Projects (Search)",
                    gtm: 'projects-search'
                }
            },
            {
                path: "project-cover-sheets",
                name: "project-cover-sheets",
                component: () =>
                    import(
                        /* webpackChunckName: "projects" */ "@/modules/projects/pages/ProjectCoverSheet.vue"
                        ),
                meta: {
                    title: "PROJECT COVER SHEETS",
                    icon: "mdi-printer",
                    pageTitle: "Projects (Cover Sheets)",
                    gtm: 'projects-cover-sheets'
                },
            },
            {
                path: 'land-entities',
                name: 'land-entities',
                component: () => import(/* webpackChunkName: "document-management" */ '@/modules/landEntities/pages/LandEntities.vue'),
                meta: {
                    title: 'LAND ENTITIES',
                    icon: 'mdi-table-search'
                }
            },
            {
                path: 'facility-infrastructure-documents',
                name: 'facility-infrastructure-documents',
                component: () => import(/* webpackChunkName: "facility-infrastructure-documents" */ '@/modules/facilityInfrastructureDocuments/pages/HistoricalArchives'),
                meta: {
                    title: 'FACILITY/INFRASTRUCTURE DOCUMENTS',
                    icon: 'mdi-file-search-outline',
                    gtm: 'facility-infrastructure-documents'
                }
            },
            {
                path: "help",
                name: "projects-help",
                component: () =>
                    import(
                        /* webpackChunckName: "document-management" */ "@/modules/projects/pages/ProjectsHelp.vue"
                        ),
                meta: {
                    title: "HELP",
                    icon: "mdi-help",
                    pageTitle: "Projects Help",
                    gtm: 'projects-help',
                    displayInNavigation: false
                },
            }
        ]
    },
    {
        path: '/document-management/land-entities/:facilityId',
        name: 'land-entity-detail',
        props: true,
        component: () => import(/* webpackChunkName: "document-managements" */ '@/modules/landEntities/pages//LandEntityDetail.vue'),
        meta: {
            title: 'LAND ENTITY',
            icon: 'mdi-table-search',
            displayInNavigation: false
        },
        children: [
            {
                path: 'projects',
                props: true,
                component: () => import(/* webpackChunkName: "land-entities" */ '@/modules/facilities/components/FacilityProjects'),
                meta: {
                    pageTitle: 'Land Entity (Projects)',
                    gtm: 'land-entity-projects',
                }
            },
            {
                path: 'documents',
                props: true,
                component: () => import(/* webpackChunkName: "land-entities" */ '@/modules/facilities/components/FacilityLinksDocuments.vue'),
                meta: {
                    pageTitle: 'Land Entity (Documents)',
                    gtm: 'land-entity-documents',
                }
            },
            {
                path: 'addresses',
                props: true,
                component: () => import(/* webpackChunkName: "land-entities" */ '@/modules/landEntities/components/LandEntityAddresses.vue'),
                meta: {
                    pageTitle: 'Land Entity (Addresses)',
                    gtm: 'land-entity-addresses',
                }
            },
            {
                path: '/',
                redirect: 'projects',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    },

]
